import React from 'react';

import { Link } from 'react-router';

function renderActions(_, { row, can, remove }) {
	const code = row.country_code;
	return (
		<div className='banners-icons'>
			<Link
				className='banners-edit-icon'
				to={`/offer-location-rules/geo-rules/edit/${code}`}
			/>
			{can('delete') && (
				<a
					className='remove-icon'
					onClick={() => {
						if (confirm(`Delete rule ${code ? `(code:${code})` : ''}?`)) {
							remove(code);
						}
					}}
				/>
			)}
		</div>
	);
}

export default [
	[
		{
			index: 'country_name',
			header: {
				className: 'text-left',
				title: 'Country'
			},
			column: {
				className: 'text-left'
			}
		},
		{
			index: 'actions',
			header: {
				title: 'actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/offer-location-rules/geo-rules/list/table-initial-data.js